import { render, staticRenderFns } from "./EipFontUeditor.vue?vue&type=template&id=08b4b24e&scoped=true&"
import script from "./EipFontUeditor.vue?vue&type=script&lang=js&"
export * from "./EipFontUeditor.vue?vue&type=script&lang=js&"
import style0 from "./EipFontUeditor.vue?vue&type=style&index=0&id=08b4b24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b4b24e",
  null
  
)

export default component.exports